import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  imports: [RouterOutlet],
  standalone: true,
})
export class AppComponent {
  private readonly translate = inject(TranslateService);

  constructor() {
    this.initTranslations();
  }

  private initTranslations(): void {
    this.translate.setDefaultLang('en');
    this.translate.use('en');
  }
}
